var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#2A7F77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7188 43.9062H45.3125V24.6875C45.3125 24.5632 45.2631 24.444 45.1752 24.356C45.0873 24.2681 44.9681 24.2188 44.8438 24.2188H38.2812C38.1569 24.2188 38.0377 24.2681 37.9498 24.356C37.8619 24.444 37.8125 24.5632 37.8125 24.6875V29.8438H31.7188C31.5944 29.8438 31.4752 29.8931 31.3873 29.981C31.2994 30.069 31.25 30.1882 31.25 30.3125V35.4688H25.1562C25.0319 35.4688 24.9127 35.5181 24.8248 35.606C24.7369 35.694 24.6875 35.8132 24.6875 35.9375V43.9062H23.2812C23.1569 43.9062 23.0377 43.9556 22.9498 44.0435C22.8619 44.1315 22.8125 44.2507 22.8125 44.375C22.8125 44.4993 22.8619 44.6185 22.9498 44.7065C23.0377 44.7944 23.1569 44.8438 23.2812 44.8438H46.7188C46.8431 44.8438 46.9623 44.7944 47.0502 44.7065C47.1381 44.6185 47.1875 44.4993 47.1875 44.375C47.1875 44.2507 47.1381 44.1315 47.0502 44.0435C46.9623 43.9556 46.8431 43.9062 46.7188 43.9062ZM32.1875 30.7812H37.8125V43.9062H32.1875V30.7812ZM25.625 36.4062H31.25V43.9062H25.625V36.4062ZM38.75 43.9062V25.1562H44.375V43.9062H38.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.a67a495c3d56cc861182a79783d7fc0c.svg";
export { ForwardRef as ReactComponent };